import React from 'react';
import { motion } from 'framer-motion';
import { Play, Target, Video } from 'lucide-react';

const WelcomeScreen = ({ onStart }) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md mx-auto text-center">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {/* Title */}
          <motion.h1
            className="text-5xl font-extralight text-dark-50 mb-3 tracking-wide"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            7 Dimensions
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            className="text-dark-400 mb-16 text-sm"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Posture assessment
          </motion.p>

          {/* Start Button */}
          <motion.button
            onClick={onStart}
            className="w-full bg-white text-black py-4 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-200 mb-8"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Begin
          </motion.button>

          {/* Minimal info */}
          <motion.p
            className="text-xs text-dark-600"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            18 postures • 45 minutes
          </motion.p>
        </motion.div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
